import { apiResourceUrl } from "@ploy-lib/core";
import paramsToString, { BaseResource } from "./BaseResource";
import { SimpleResource } from "@rest-hooks/rest";

export interface ApplicationMortgageERegistrationData {
	readonly applicationId?: number;
	readonly applicationMortgageERegistrationId?: number;
	readonly documentYear?: string;
	readonly documentNumber?: string;
	readonly documentOffice?: string;
	readonly message?: string;
	readonly status?: string;
	readonly registrationDate?: string;
	readonly registrationTime?: string;
}

export class ApplicationMortgageERegistrationResource
	extends BaseResource
	implements ApplicationMortgageERegistrationData
{
	readonly applicationId?: number = undefined;
	readonly applicationMortgageERegistrationId?: number = undefined;
	readonly documentYear?: string = undefined;
	readonly documentNumber?: string = undefined;
	readonly documentOffice?: string = undefined;
	readonly message?: string = undefined;
	readonly status?: string = undefined;
	readonly registrationDate?: string = undefined;
	readonly registrationTime?: string = undefined;

	pk(parent?: any, key?: string): string | undefined {
		return `${this.applicationId?.toString()}`;
	}

	static url<T extends typeof SimpleResource>(
		this: T,
		urlParams: Readonly<Record<string, any>>
	) {
		const { applicationId, ...searchParams } = urlParams;

		const url = super.url(urlParams);

		return `${url}${paramsToString(searchParams)}`;
	}

	static urlRoot = apiResourceUrl("mortgage-eregistration");
}
